
import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Divider, Row, Col, Tooltip } from "antd";
import BreadcrumbComponent from "../../../CommonComponents/Breadcrumb/Breadcrumb";
import { getPrimaryAccount } from '../../../utils/sessionUtil';
import CardWapper from "./../Components/CardWapper";
import formatter from '../../../utils/formatter';
import { fetchOtherTransactionDetails, clearOtherTransactionDetails } from "./actions"
import PagePrintButton from "../../../CommonComponents/PrintButton/PagePrintButton";
import Preloader from '../../../CommonComponents/Preloader/Preloader';
import {
  OtherTransactionHeading,
  CustomizedFlowCard,
  Heading,
  SectionHeading,
  FlexContainer,
  CustomSectionSpacing,
  PoolTable,
  PrintBtn,
  ContentMaker,
  ReversedSection,
  Pipe
} from "./styles";
import {
  FixedWidth,
  SectionSpacing,
  SummaryLabel,
  SummaryData,
  DataHeading,
  GhostButtonComponent,
  UnderlinePurpose
} from "../../../CommonComponents/commonStyles";
import { replaceSelect } from "../../../utils/replacer";


export const renderFixGrid = ({ gridName, value, additionalComments, index }) => {
  return (
    <>
      <DataHeading className='mb-5'>{gridName}</DataHeading>

      {
        additionalComments && index === 0
          ?
          <Tooltip
            placement="bottom"
            title={<ContentMaker>
              {additionalComments ? additionalComments : "No additional comments."}
            </ContentMaker>}
          >
            <UnderlinePurpose>{value ? value : '-'}</UnderlinePurpose>
          </Tooltip>
          :
          <Heading>{value ? value : '-'}</Heading>

      }
    </>
  )
};

export const renderAmount = (amount) => {
  if (amount && amount > 0 || amount < 0) {
    let dollarsAmount = formatter({
      value: amount,
      fieldSuffix: 'Dollars',
    });
    return dollarsAmount;
  } else if (amount === 0) {
    return (<span>$0.00</span>)
  } else {
    return '-';
  }
}

export const renderPercentage = (percentage) => {
  return percentage ? percentage + '%' : (percentage === 0) ? '0%' : '-';
}

const breadcrumbRoutes = () => {
  return [
    {
      routeName: "Home",
      path: "/#"
    },
    {
      routeName: "My Account",
      path: "/my-account"
    },
    {
      routeName: "Transaction Summary",
      path: "/my-account/transaction-summary"
    },
    {
      routeName: "Other Transaction",
      path: "/my-account/other-transaction"
    }
  ];
};


const styleConfig = {
  cardBorder: false,
};

export const column = [
  {
    title: 'Investment Options',
    render: (text) => replaceSelect(text.name),
    key: 'name',
    width: '25%',
  },
  {
    title: 'Dollar',
    render: (text) => text.dollarAmount,
    key: 'name',
    width: '25%',
  },
  {
    title: 'Units',
    render: (text) => text.unit,
    key: 'name',
    width: '25%',
  },
  {
    title: 'Percentage',
    render: (text) => text.percentage,
    key: 'name',
    width: '25%',
  }
]


export const OtherTransactionDetails = ({ history, fetchOtherTransactionDetails, clearOtherTransactionDetails, otherTransactionDetailsLoading, otherTransactionDetails = {} }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [otherFormattedDetails, setOtherFormattedDetails] = useState([])
  const [summary, setSummary] = useState([])
  const printRef = React.createRef();

  useEffect(() => {
    fetchOtherTransactionDetails({
      method: "GET",
      page: "otherTransaction",
      url: `/donor-portal/api/account/${
        getPrimaryAccount().userId
        }/findSingleTransactionDetailsByAccountIdAndTransactionId?transactionId=${history.location.state.transactionId}`
    });
    window.scrollTo(0, 0);
  }, [])

  useEffect(() => {
    let otherTransactionFormattedDetails = [];
    let columnSummary = []
    if (otherTransactionDetails.investmentOptionsDetails) {
      otherTransactionDetails.investmentOptionsDetails.map((data) => {
        otherTransactionFormattedDetails.push({
          name: data.name,
          dollarAmount: data.transactionType === 'IN' ? renderAmount(data.dollarAmount) : `(${renderAmount(data.dollarAmount)})`,
          unit: data.transactionType === 'IN' ? Math.abs(data.unit) : `(${Math.abs(data.unit)})`,
          percentage: renderPercentage(data.percentage),
        })
      })
    }
    if (otherTransactionDetails.summary) {
      otherTransactionDetails.summary.map((data, i) => {
        columnSummary.push({
          gridWidth: '50',
          type: 'FixGrid',
          render: renderFixGrid({
            gridName: data.title,
            value: data.value,
            additionalComments: otherTransactionDetails.additionalComments,
            index: i
          }),
        })
      })
    }
    setSummary(columnSummary)
    setIsLoading(otherTransactionDetailsLoading)
    setOtherFormattedDetails(otherTransactionFormattedDetails)
  }, [otherTransactionDetails])

  useEffect(() => {
    setIsLoading(otherTransactionDetailsLoading)
    return () => {
      clearOtherTransactionDetails()
    }
  }, [])

  const backClicked = () => {
    if (history.location.state && history.location.state.redirectFromGemini) {
      history.push("/");
    } else {
      history.goBack();
    }
  }

  const isTransferIn = otherTransactionDetails.investmentOptionsDetails && otherTransactionDetails.investmentOptionsDetails.length > 0 && otherTransactionDetails.investmentOptionsDetails[0].transactionType === "OUT"
  const amountConfig = [
    {
      name: 'totalAmount:',
      gridWidth: '50',
      type: 'FixGrid',
      className: 'grid-with-border',
      render: renderFixGrid({
        gridName: 'Total Amount:',
        value: isTransferIn ? `(${renderAmount(otherTransactionDetails.totalAmount)})` : renderAmount(otherTransactionDetails.totalAmount)
      }),
      pbottom: true,
    }
  ];
  return (
    <FixedWidth data-test="other-transaction-details">
      <BreadcrumbComponent breadcrumbRoutes={breadcrumbRoutes()} />

      <PrintBtn>
        <PagePrintButton
          id="anrPrint"
          className='ml-auto'
          contentRef={() => printRef.current}
        />
      </PrintBtn>

      <div ref={printRef}>
        <OtherTransactionHeading>{`Transaction ID: ${history.location.state.transactionId}`}</OtherTransactionHeading>
        <SectionSpacing className="mb-30">
          <Row>
            <Col xs={12} md={24}>
              <SummaryLabel>{getPrimaryAccount().accountName}</SummaryLabel>
            </Col>
            <Col xs={12} md={24}>
              <SummaryData>{getPrimaryAccount().accountNumber}</SummaryData>
            </Col>
          </Row>
        </SectionSpacing>
        {
          isLoading
            ?
            <Preloader />
            :
            <>
              {(otherTransactionDetails.reverseDate && otherTransactionDetails.currentStatus) &&
                <ReversedSection>
                  <div>
                    <DataHeading>Reversed Date:</DataHeading>&nbsp;&nbsp;
          <Heading>{otherTransactionDetails.reverseDate}</Heading>
                  </div>
                  <Pipe />
                  <div>
                    <DataHeading>Current status:</DataHeading>&nbsp;&nbsp;
          <Heading>{otherTransactionDetails.currentStatus}</Heading>
                  </div>
                </ReversedSection>
              }
              <Divider className="m0" />
              <CustomSectionSpacing >
                <Row>
                  <Col span={24} md={11}>
                    <FlexContainer>
                      <SectionHeading>{otherTransactionDetails.summaryType}</SectionHeading>
                    </FlexContainer>
                    <CustomizedFlowCard>
                      <CardWapper
                        cardConfig={summary}
                        styleConfig={styleConfig}
                      />
                    </CustomizedFlowCard>
                  </Col>
                </Row>
              </CustomSectionSpacing>
              <Divider className="m0" />
              <CustomSectionSpacing>
                <Row>
                  <Col span={24} md={11}>
                    <FlexContainer>
                      <SectionHeading>Amount and allocations</SectionHeading>
                    </FlexContainer>
                    <CustomizedFlowCard>
                      <CardWapper
                        cardConfig={amountConfig}
                        styleConfig={styleConfig}
                      />
                    </CustomizedFlowCard>
                  </Col>
                </Row>
                {
                  otherTransactionDetails.currentStatus !== "Entered"
                    ?
                    <Row>
                      <Col xs={24} lg={24}>
                        <PoolTable
                          data-test="other-transaction-details-column"
                          pagination={false}
                          columns={column}
                          dataSource={otherFormattedDetails}
                          rowKey={(record) => record.poolId} />
                      </Col>
                    </Row>
                    : null
                }
              </CustomSectionSpacing>
            </>
        }
        <Divider className="m0" />
        <GhostButtonComponent
          mt="50px"
          width="150px"
          onClick={() => backClicked()}
        >
          Back
        </GhostButtonComponent>
      </div>
    </FixedWidth>
  )
}

OtherTransactionDetails.propTypes = {
  otherTransactionDetails: PropTypes.object,
  otherTransactionDetailsLoading: PropTypes.object,
  fetchOtherTransactionDetails: PropTypes.func.isRequired,
  clearOtherTransactionDetails: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  otherTransactionDetails: state.getIn(["transactionSummary", "otherTransactionDetails"]),
  otherTransactionDetailsLoading: state.getIn(["transactionSummary", "otherTransactionDetailsLoading"]),
})

const mapDispatchToProps = dispatch => ({
  fetchOtherTransactionDetails: data => dispatch(fetchOtherTransactionDetails(data)),
  clearOtherTransactionDetails: () => dispatch(clearOtherTransactionDetails()),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OtherTransactionDetails)
);
